module.exports = __webpack_public_path__ + "img/tf3661_center_003.2c0f1d4f.png";